import React from 'react'
import Adminlayout from '../Adminlayout'

const Support = () => {
  return (

    <Adminlayout>
         <div>
            Working on it
         </div>
    </Adminlayout>
   
  )
}

export default Support